import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import API_LICENSE_KEY_CONTROLLER from '../../controllers/apiLicenseKey';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import RetrieveLicenseKeySection from './RetrieveLicenseKeySection';
import getClientConfig from '../../utils/getClientConfig';

export const ApiLicenseKeyPage = (props) => {
    const { licenseKeyRetrievalLogLink } = getClientConfig();

    return (
        <div className="content-area" data-testid="component-api-license-key-page">
            <s-container>
                <h1>
                    <LanguageStringResolver string='apiLicenseKey_Title' />
                </h1>
                <p className="mb30">
                    <LanguageStringResolver string='apiLicenseKey_SubHeading' />
                </p>

                <s-alert status="info" nodismiss={true} class="mb20" data-testid="api-license-key-audit-notice">
                    <div>
                        <h4 className="margin-top-none margin-bottom-xs">
                            <LanguageStringResolver string='apiLicenseKey_AuditNoticeHeading' />
                        </h4>
                        <p><LanguageStringResolver string='apiLicenseKey_AuditInfo' /></p>
                        <Link className="button secondary" to={licenseKeyRetrievalLogLink} data-testid="api-license-key-audit-notice-dynamic-reports-link">
                            <LanguageStringResolver string='apiLicenseKey_DynamicReportsLink' />
                        </Link>
                    </div>
                </s-alert>

                <RetrieveLicenseKeySection
                    languages={props.languages}
                    onRetrieveLicenseKey={props.onRetrieveLicenseKey}
                />
            </s-container>
        </div>
    );
};


export function mapStateToProps(state) {
    return {
        languages: state.languages
    };
}

export function mapDispatchersToProps(dispatch) {
    return {
        onRetrieveLicenseKey: () => dispatch(API_LICENSE_KEY_CONTROLLER.doRetrieveLicenseKey())
    };
}

export default authorize(
    {
        name: 'ApiLicenseKey',
        resource: connect(mapStateToProps, mapDispatchersToProps)(ApiLicenseKeyPage)
    },
    AuthorizedResource,
    {
        showNotAuthorized: true
    }
);
